import { Button, Modal } from "antd";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import parse from "html-react-parser";
import { inject, observer } from "mobx-react";
import React from "react";
import { Link } from "react-router-dom";
import icon from "../../assets/images/error-modal-icon.png";
import icon_check_circle from "../../assets/images/icon-check-circle.svg";
import icon_false_circle from "../../assets/images/icon-false-circle.svg";
import Banner from "../../assets/images/newbanner2.png";
// import { Constants } from "../../core/helpers/constants";
import { Helpers } from "../../core/helpers/helpers";
import { PaymentFailedDto } from "../../core/interfaces/payment-failed.dto";
import { QuestionState } from "../../core/interfaces/question.state";
import { IUserInfo } from "../../core/interfaces/user";
import FireRemoteService from "../../core/services/fire-remote";
import QuestionService from "../../core/services/question";
import UserService from "../../core/services/user";
import WalletService from "../../core/services/wallet";
import fire from "../../fire";
import AppStore from "../../Store";
import TermsConditionsPage from "../terms-conditions/terms-conditions";
import WalletPage from "../wallet/wallet";
import "./question.scss";
dayjs.extend(duration);

declare global {
  interface Window {
    paymentFailed: any;
    tokenBalanceCheckCompleted: any;
    noAction: any;
  }
}

@inject("appStore")
@observer
export default class QuestionPage extends React.Component<
  { appStore: AppStore; location: Location },
  QuestionState
> {
  public static url: string = "/question";
  private videoQuestionRef: React.RefObject<HTMLVideoElement>;

  constructor(props: any) {
    super(props);
    this.videoQuestionRef = React.createRef();
    this.bindInAppPurchaseSuccess();
    this.bindInAppPurchaseFail();
    this.bindInAppNoAction();

    window.addEventListener(
      "message",
      (event) => {
        if (event.data === "tokenBalanceCheckCompleted") {
          window.tokenBalanceCheckCompleted();
        }

        if (event.data === "noAction") {
          window.noAction();
        }
      },
      false
    );

    window.addEventListener("triggerCheckTokenBalance", () => {
      this.handleCheckTokenBalanceFromModal();
    });

    window.addEventListener("triggerGetRandomQuestion", () => {
      this.getRandomQuestion();
    });
  }

  private questionService: QuestionService = new QuestionService();
  private userService: UserService = new UserService();
  private walletService: WalletService = new WalletService();
  private questionClickTimeout: any;
  private timerInterval: any;

  state: QuestionState = {
    isPaymentFailModalVisible: false,
    paymentFailReason: "",
    isVideoQuestionModalVisible: false,
    randomQuestion: undefined,
    answerId: undefined,
    userInfo: {
      id: 0,
      msisdn: "",
      stampCount: 0,
      stampExpireRemaining: 4,
      termsConfirmationDate: false,
      isDCBUser: false,
    },
    timerDuration: undefined,
    timerSeconds: -1,
    tokenBalance: undefined,
  };

  /**
   * Logic copied from wallet-success page
   */
  private bindInAppPurchaseSuccess = (): void => {
    window.tokenBalanceCheckCompleted = async (payload: string) => {
      // const response: PaymentSuccessDto = JSON.parse(payload);
      // const { transactionId, receipt } = response;
      try {
        const paymentResponse = await this.walletService.walletPaymentSuccess(
          // transactionId,
          // receipt,
          this.props.appStore.answerId
        );

        this.props.appStore.chosenAnswerIndex =
          paymentResponse.chosenAnswerIndex;
        this.props.appStore.correctAnswerIndex =
          paymentResponse.correctAnswerIndex;
        // Set isOfferAccepting to false first to allow indicators to show briefly
        this.props.appStore.isOfferAccepting = false;
        // Small delay to show indicators before congratulations modal appears
        setTimeout(() => {
          this.props.appStore.isCongratulationsModalVisible = true;
          this.props.appStore.answerId = undefined;
          this.props.appStore.questionId = undefined;
        }, 500); // 500ms delay to show red/green indicators
      } catch (error) {
        this.props.appStore.handleUnknownErrorModalVisibility(true);
        this.props.appStore.isOfferAccepting = false;
        console.error(error);
      }
    };
  };

  /**
   * Logic copied from wallet-fail page
   */
  private bindInAppPurchaseFail = (): void => {
    window.paymentFailed = async (payload: string) => {
      const response: PaymentFailedDto = JSON.parse(payload);
      const { transactionId, reason } = response;
      this.props.appStore.isOfferAccepting = false;
      try {
        await this.walletService.walletPaymentFail(transactionId);
        this.setState({
          isPaymentFailModalVisible: true,
          paymentFailReason: reason,
        });
      } catch (error) {
        this.props.appStore.handleUnknownErrorModalVisibility(true);
        console.error(error);
      }
    };
  };

  private bindInAppNoAction = (): void => {
    window.noAction = () => {
      console.log("noAction");
      this.props.appStore.isOfferAccepting = false;
      this.props.appStore.answerId = undefined;
      this.props.appStore.questionId = undefined;
      this.props.appStore.chosenAnswerIndex = undefined;
      this.props.appStore.correctAnswerIndex = undefined;
    };
  };

  handleModalPaymentFailed = () => {
    this.setState({
      isPaymentFailModalVisible: false,
      paymentFailReason: "",
    });
  };

  handleVideoClick = (isVideoQuestionModalVisible: boolean) => {
    if (isVideoQuestionModalVisible === false) {
      this.videoQuestionRef.current!.pause();
    }
    this.setState({
      isVideoQuestionModalVisible,
    });
  };

  componentWillUnmount() {
    this.props.appStore.is500MBModalVisible = false;
    this.props.appStore.is1GBWinModalVisible = false;
    this.props.appStore.isUserWinThreeStampModalVisible = false;
    this.props.appStore.isUserAnsweredWrongThirdQuestionModalVisible = false;
    clearInterval(this.timerInterval);

    window.removeEventListener(
      "triggerAnswerValidationPayment",
      this.handleAnswerValidationPayment
    );
    window.removeEventListener(
      "triggerCheckTokenBalance",
      this.handleCheckTokenBalanceFromModal
    );
    window.removeEventListener(
      "triggerGetRandomQuestion",
      this.getRandomQuestion
    );
  }

  private getWalletRedirectUrl(): string {
    return WalletPage.url;
  }

  private async goToWalletPage(): Promise<void> {
    this.handleCheckTokenBalance();
  }

  private handleCheckTokenBalance = (title?: string, desc?: string): void => {
    try {
      (window as any).webkit.messageHandlers.checkTokenBalance.postMessage(
        JSON.stringify({
          iosProductId: `${process.env.REACT_APP_IOS_PRODUCT_ID}`,
          title: title || "",
          desc: desc || "",
        })
      );
    } catch (e) {}
    try {
      (window as any).JSBridge.checkTokenBalance(
        JSON.stringify({
          androidProductId: `${process.env.REACT_APP_ANDROID_PRODUCT_ID}`,
          title: title || "",
          desc: desc || "",
        })
      );
    } catch (e) {}
    try {
      window.parent.postMessage("checkTokenBalance", "*");
    } catch (e) {}
  };

  handleAnswerValidationPayment = async (): Promise<void> => {
    if (this.props.appStore.token && this.props.appStore.answerId) {
      try {
        await this.setUserOption(
          this.getOptionLetterAbcd(this.props.appStore.chosenAnswerIndex || 0)
        );

        const questionTitle = this.state.randomQuestion
          ? this.state.randomQuestion.text
          : "";
        const questionDesc = `Question ID: ${
          this.state.randomQuestion ? this.state.randomQuestion.id : ""
        }`;

        this.props.appStore.isAnswerValidationModalVisible = false;

        this.handleCheckTokenBalance(questionTitle, questionDesc);
      } catch (error) {
        console.error("Payment initiation failed:", error);
        this.props.appStore.handleUnknownErrorModalVisibility(true);
        this.props.appStore.isOfferAccepting = false;
      }
    }
  };

  handleCheckTokenBalanceFromModal = (): void => {
    this.props.appStore.isCongratulationsModalVisible = false;
    this.props.appStore.isAnswerValidationModalVisible = false;

    const title = "Tebrikler! Doğru cevap verdin.";
    const desc =
      "1.000 FreeByte'ın anında cüzdanına yüklenmesi için 10 PLY gerekiyor.";
    console.log("1: ", this.state.tokenBalance);
    if (this.state.tokenBalance !==undefined && this.state.tokenBalance < 10) {
      this.handleCheckTokenBalance(title, desc);
    } else {
      this.setState({
        tokenBalance: undefined,
      });
      window.tokenBalanceCheckCompleted();
    }
  };

  startTimer() {
    clearInterval(this.timerInterval);
    this.timerInterval = setInterval(() => {
      const timerSeconds = this.state.timerSeconds - 1;
      const timerDuration = dayjs.duration(timerSeconds * 1000);
      this.setState({ timerSeconds, timerDuration }, () => {
        if (this.state.timerSeconds === 0) {
          clearInterval(this.timerInterval);
          console.log("timer stopped");
          window.location.reload();
        }
      });
    }, 1000);
  }

  async componentDidMount() {
    if (this.props.appStore.token) {
      this.getUserInfo();
    }
    if (
      this.props.appStore.answerId &&
      this.props.appStore.questionId &&
      this.props.appStore.token
    ) {
      this.getQuestion(this.props.appStore.questionId);
      this.setState({
        answerId: this.props.appStore.answerId,
      });
    } else {
      this.getRandomQuestion();
    }
  }

  async getRandomQuestion(): Promise<void> {
    try {
      const randomQuestion = await this.questionService.getRandomQuestion();
      const token = window.localStorage.getItem("token");
      if (token) {
        fetch(`${process.env.REACT_APP_USER_BALANCE_URL}`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            console.log("fetch data: ", data);
            this.setState({
              tokenBalance: data.tokenBalance,
            });
            this.props.appStore.tokenBalance = data.tokenBalance;
            return data;
          });
      }

      if (randomQuestion) {
        this.setState({
          randomQuestion,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getQuestion(questionId: number): Promise<void> {
    try {
      const randomQuestion = await this.questionService.getQuestion(questionId);
      if (randomQuestion) {
        this.setState({
          randomQuestion,
          answerId: this.props.appStore.answerId,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  private dispatchUserInfoEvent(userInfo: IUserInfo) {
    const body = {
      stampCount: userInfo.stampCount,
      stampExpireDate: this.getStampExpireDate(userInfo.stampExpireRemaining),
    };
    const payload = JSON.stringify(body);
    try {
      (window as any).webkit.messageHandlers.triggerLoyality.postMessage(
        payload
      );
    } catch (e) {
      // console.log('UserInfo webkit event error!', e);
    }
    try {
      (window as any).JSBridge.receiveMessage(payload);
    } catch (e) {
      // console.log('UserInfo JSBridge error!', e);
    }
  }

  private getStampExpireDate(stampExpireRemaining: number): string {
    return dayjs().add(stampExpireRemaining, "second").format();
  }

  async getUserInfo(): Promise<void> {
    try {
      const userInfo = await this.userService.getUserInfo();
      if (userInfo) {
        this.props.appStore.setUser(userInfo);

        // const expireDate = dayjs().add(userInfo.stampExpireRemaining, "second").format();

        fire
          .analytics()
          .setUserProperties({ stamp_count: userInfo.stampCount });
        fire.analytics().setUserProperties({
          stamp_expire_date: this.getStampExpireDate(
            userInfo.stampExpireRemaining
          ),
        });
        this.dispatchUserInfoEvent(userInfo);

        this.setState(
          {
            userInfo,
          },
          () => {
            if (this.state.userInfo!.stampExpireRemaining !== 0) {
              this.setState(
                {
                  timerSeconds: this.state.userInfo!.stampExpireRemaining || -1,
                },
                () => this.startTimer()
              );
            }
          }
        );
      }
    } catch (error) {
      if ((error as any).response.status === 410) {
        this.props.appStore.token = undefined;
        fire.analytics().logEvent("more_than_1_login_device");
      }
      // this.props.appStore.token = undefined; // Bu burda yapılmaz. Http servisi içinde global yapılmalı.
    }
  }
  private async setUserOption(value: string): Promise<void> {
    try {
      const result = await this.userService.setUserOption(value);
      console.log(result);
    } catch (error) {
      console.log(error);
      if ((error as any).response.status === 410) {
        this.props.appStore.token = undefined;
      }
    }
  }

  private dispatchOptionClickedEvent() {
    try {
      (window as any).webkit.messageHandlers.optionClick.postMessage(
        JSON.stringify({ status: "Clicked" })
      );
    } catch (e) {}
    try {
      (window as any).JSBridge.optionClicked();
    } catch (e) {}
  }

  handleQuestionClick = async (
    answerId: number,
    questionId: number,
    chosenAnswerIndex: number,
    answerIndex: number
  ) => {
    clearTimeout(this.questionClickTimeout);

    this.props.appStore.isOfferAccepting = true;

    this.props.appStore.answerId = answerId;
    this.props.appStore.questionId = questionId;
    this.props.appStore.chosenAnswerIndex = chosenAnswerIndex;

    this.setState({
      answerId,
    });

    if (this.props.appStore.isLoggedIn) {
      fire.analytics().logEvent("login_qn_button_count");
    } else {
      fire.analytics().logEvent("logout_qn_button_count");
    }

    if (chosenAnswerIndex === 0) {
      fire.analytics().logEvent("answer_a_clicked");
      this.dispatchOptionClickedEvent();
    } else if (chosenAnswerIndex === 1) {
      fire.analytics().logEvent("answer_b_clicked");
      this.dispatchOptionClickedEvent();
    } else if (chosenAnswerIndex === 2) {
      fire.analytics().logEvent("answer_c_clicked");
      this.dispatchOptionClickedEvent();
    } else if (chosenAnswerIndex === 3) {
      fire.analytics().logEvent("answer_d_clicked");
      this.dispatchOptionClickedEvent();
    }

    try {
      const currentQuestion = this.state.randomQuestion;

      if (currentQuestion) {
        let correctAnswerIndex = -1;
        let isAnswerCorrect = false;

        currentQuestion.answers.forEach((answer, index) => {
          if (answer.isCorrect) {
            correctAnswerIndex = index;
          }
          if (answer.id === answerId) {
            isAnswerCorrect = answer.isCorrect || false;
          }
        });

        this.props.appStore.correctAnswerIndex = correctAnswerIndex;
        this.props.appStore.isAnswerCorrect = isAnswerCorrect;

        if (!isAnswerCorrect) {
          this.props.appStore.isAnswerValidationModalVisible = false;

          await this.setUserOption(this.getOptionLetterAbcd(chosenAnswerIndex));
          const questionTitle = currentQuestion.text;
          const questionDesc = `Question ID: ${currentQuestion.id}`;

          // Directly call checkTokenBalance without showing modal

          this.handleCheckTokenBalance(questionTitle, questionDesc);
        } else {
          // Show modal for correct answers
          this.props.appStore.isAnswerValidationModalVisible = true;
        }
      }
    } catch (error) {
      console.error("Answer validation failed:", error);
      this.props.appStore.handleUnknownErrorModalVisibility(true);
      this.props.appStore.isOfferAccepting = false;
    }
  };

  getCurrentQuestionNumber = (): number => {
    return this.state.userInfo
      ? Math.min(this.state.userInfo.stampCount + 1, 3)
      : 1;
  };

  getStampCount = (): number => {
    return this.state.userInfo ? this.state.userInfo.stampCount : 0;
  };

  setTimerSeconds = () => {
    this.setState({
      timerSeconds: this.state.userInfo!.stampExpireRemaining || -1,
    });
  };

  getOptionLetterAbcd = (index: number): string => {
    switch (index) {
      case 0:
        return "A";
      case 1:
        return "B";
      case 2:
        return "C";
      case 3:
        return "D";
      default:
        return "";
    }
  };

  render() {
    return (
      <div id="question">
        {this.state.randomQuestion && this.state.randomQuestion.answers && (
          <div className="inner-container">
            {this.props.appStore.token && this.state.userInfo && (
              <div>
                {/* <StampBanner
                  stampCount={this.state.userInfo.stampCount}
                  timerDuration={this.state.timerDuration}
                  timerSeconds={this.state.timerSeconds}
                /> */}

                <div className="gift-banner">
                  <img src={Banner} alt="banner" />
                </div>
              </div>
            )}

            <div className="question-content">
              {/* <div className="stampCount">
                {this.state.userInfo && this.state.userInfo.stampCount + 1}.
                soru
              </div> */}
              {this.state.randomQuestion.type === "VIDEO" && (
                <div>
                  <div className="row mx-0 mb-2 d-flex align-items-center mb-md-5">
                    <div className="col-sm-12 col-md-5 p-0 ">
                      <div
                        className="question-video"
                        onClick={() => this.handleVideoClick(true)}
                      >
                        <img
                          className="video-image"
                          src={
                            this.state.randomQuestion.videoImageUrl ||
                            "/assets/images/video-image.png"
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-7 p-0">
                      <div className="question-text">
                        {this.state.randomQuestion.text}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {this.state.randomQuestion.type === "TEXT" && (
                <div>
                  <div className="question-text">
                    {this.state.randomQuestion.text}
                  </div>
                </div>
              )}

              <div className="row m-0">
                {this.state.randomQuestion.answers.map((answer, i) => {
                  return (
                    <div
                      key={i}
                      className="opt-container col-sm-12 col-md-6 p-0"
                    >
                      <Button
                        onClick={() =>
                          !this.props.appStore.isOfferAccepting
                            ? this.handleQuestionClick(
                                answer.id,
                                this.state.randomQuestion!.id,
                                i,
                                answer.answerIndex
                              )
                            : console.error("Tıklayamazsın :)")
                        }
                        className={`question-button w-100
                        ${
                          !(
                            this.props.appStore
                              .isAnswerValidationModalVisible ||
                            this.props.appStore.isOfferAccepting
                          ) &&
                          this.props.appStore.correctAnswerIndex !==
                            undefined &&
                          this.props.appStore.chosenAnswerIndex === i &&
                          this.props.appStore.correctAnswerIndex !== i
                            ? "false"
                            : ""
                        }
                        ${
                          this.props.appStore.chosenAnswerIndex === i ||
                          this.props.appStore.answerId === answer.id
                            ? "active"
                            : ""
                        }
                        ${
                          !(
                            this.props.appStore
                              .isAnswerValidationModalVisible ||
                            this.props.appStore.isOfferAccepting
                          ) &&
                          this.props.appStore.correctAnswerIndex !==
                            undefined &&
                          this.props.appStore.correctAnswerIndex === i
                            ? "correct"
                            : ""
                        }
                          `}
                      >
                        <div className="btn-inner-container">
                          <div className="option-container">
                            {(() => {
                              const isModalVisible =
                                this.props.appStore
                                  .isAnswerValidationModalVisible ||
                                this.props.appStore.isOfferAccepting;

                              // Only show icons if answer is validated and no modal is visible
                              if (
                                !isModalVisible &&
                                this.props.appStore.correctAnswerIndex !==
                                  undefined
                              ) {
                                if (
                                  this.props.appStore.chosenAnswerIndex === i &&
                                  this.props.appStore.correctAnswerIndex !== i
                                ) {
                                  return (
                                    <img
                                      className="option-letter"
                                      src={icon_false_circle}
                                      alt="incorrect"
                                    />
                                  );
                                } else if (
                                  this.props.appStore.correctAnswerIndex === i
                                ) {
                                  return (
                                    <img
                                      className="option-letter"
                                      src={icon_check_circle}
                                      alt="correct"
                                    />
                                  );
                                }
                              }
                              // Default: show letter
                              return (
                                <span className="option-letter">
                                  {this.getOptionLetterAbcd(answer.answerIndex)}
                                </span>
                              );
                            })()}
                          </div>
                          <div className="option-content-container">
                            {answer.text}
                          </div>
                        </div>
                      </Button>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* {this.getStampCount() === 0 && (
              <img
                className={`question-card second ${this.getStampCount()}`}
                src={stampLayer4}
                alt="stamp"
              />
            )}

            {this.getStampCount() === 1 && (
              <img
                className={`question-card second ${this.getStampCount()}`}
                src={stampLayer3}
                alt="stamp"
              />
            )}
            {this.getStampCount() === 2 && (
              <img
                className={`question-card second ${this.getStampCount()}`}
                src={stampLayer2}
                alt="stamp"
              />
            )}
            {this.getStampCount() === 3 && (
              <img
                className={`question-card second ${this.getStampCount()}`}
                src={stampLayer1}
                alt="stamp"
              />
            )} */}

            {Helpers.isRepublicDay() && (
              <div className="terms-conditions">
                Kampanya katılım koşullarına ulaşmak için{" "}
                <Link to={TermsConditionsPage.url}>tıklayınız</Link>.
              </div>
            )}
          </div>
        )}

        {this.state.randomQuestion && (
          <Modal
            visible={this.state.isVideoQuestionModalVisible}
            footer={null}
            onCancel={() => this.handleVideoClick(false)}
            closable={false}
            centered
            className="video-modal"
          >
            <video
              className="video-question"
              id="video"
              controls
              autoPlay
              ref={this.videoQuestionRef}
            >
              <source
                src={this.state.randomQuestion.videoUrl}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </Modal>
        )}

        {this.state.isPaymentFailModalVisible && (
          <Modal
            className="error-modal"
            visible
            onCancel={() => this.handleModalPaymentFailed()}
            footer={false}
            closable={true}
            centered
            closeIcon={
              <img
                className="modal-icon-close"
                src="https://yaani.tcellcdn.net/kazankazan/icon-close.svg"
                alt="icon close"
              />
            }
          >
            <div id="error-modal-body">
              <img className="icon" src={icon} alt="error" />
              <p className="title">
                {parse(
                  FireRemoteService.getStringValue(
                    FireRemoteService.paymentFailMessageForCodeHeader +
                      this.state.paymentFailReason
                  )
                )}
              </p>
              <p className="text">
                {parse(
                  FireRemoteService.getStringValue(
                    FireRemoteService.paymentFailMessageForCode +
                      this.state.paymentFailReason
                  )
                )}
              </p>
              <Button
                onClick={() => this.handleModalPaymentFailed()}
                className="modal-button primary"
              >
                {parse(
                  FireRemoteService.getStringValue(
                    FireRemoteService.paymentErrorButton
                  )
                )}
              </Button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}
